import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["x-data"]
const _hoisted_2 = { class: "container px-6 py-4 mx-auto" }
const _hoisted_3 = { class: "lg:flex lg:items-center lg:justify-between" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { href: "/" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex lg:hidden" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M4 8h16M4 16h16"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "flex flex-col -mx-6 lg:flex-row lg:items-center lg:mx-8" }
const _hoisted_13 = { class: "flex items-center justify-center mt-4 lg:mt-0" }
const _hoisted_14 = {
  type: "button",
  class: "flex items-center focus:outline-none",
  "aria-label": "toggle profile dropdown"
}
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=334&q=80",
  class: "object-cover w-full h-full rounded-full",
  alt: "avatar",
  title: "Khatab wedaa"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 font-bold" }, "Login", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-bold" }, "Logout", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    "x-data": _ctx.isOpen,
    class: "relative bg-white shadow dark:bg-gray-800"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("img", {
              class: "w-auto h-12",
              src: 
                require('public/Prismatic-Lotus-Flower-13-No-Background.svg')
              
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              "x-cloak": "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen)),
              type: "button",
              class: "text-gray-500 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none focus:text-gray-600 dark:focus:text-gray-400",
              "aria-label": "toggle menu"
            }, [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([[_ctx.isOpen && 'hidden'], "w-6 h-6"]),
                "x-show": "!isOpen",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, _hoisted_9, 2)),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([[!_ctx.isOpen && 'hidden'], "w-6 h-6"]),
                "x-show": "isOpen",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, _hoisted_11, 2))
            ])
          ])
        ]),
        _createElementVNode("div", {
          "x-cloak": "",
          class: _normalizeClass([[
            _ctx.isOpen
              ? 'translate-x-0 opacity-100 '
              : 'opacity-0 -translate-x-full',
          ], "absolute inset-x-0 z-20 w-full px-6 py-4 transition-all duration-300 ease-in-out bg-white dark:bg-gray-800 lg:mt-0 lg:p-0 lg:top-0 lg:relative lg:bg-transparent lg:w-auto lg:opacity-100 lg:translate-x-0 lg:flex lg:items-center"])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: { name: 'AboutPage' },
              class: "px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            }, {
              default: _withCtx(() => [
                _createTextVNode("About")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'ShopPage' },
              class: "px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Shop")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'ContactPage' },
              class: "px-3 py-2 mx-3 mt-2 text-gray-700 transition-colors duration-300 transform rounded-md lg:mt-0 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Contact")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_ctx.isAuthenticated)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu = !_ctx.openMenu)),
                      class: "w-16 h-16 overflow-hidden border-2 border-gray-400 rounded-full relative z-10 block transition-colors duration-300 transform hover:bg-purple-500 focus:outline-none focus:ring focus:ring-purple-300 focus:ring-opacity-80"
                    }, _hoisted_17))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { name: 'LoginPage' },
                      class: "flex items-center px-4 py-2 font-medium tracking-wide text-white w-full capitalize justify-center transition-colors duration-300 transform rounded-lg focus:outline-none focus:ring bg-purple-600 focus:ring-opacity-80"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        _hoisted_19
                      ]),
                      _: 1
                    })),
                _createElementVNode("div", {
                  class: _normalizeClass([[!_ctx.openMenu && 'hidden'], "absolute right-0 z-20 w-48 mt-2 overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800"]),
                  "x-show": "openMenu",
                  "x-transition:enter": "transition ease-out duration-100",
                  "x-transition:enter-start": "opacity-0 scale-90",
                  "x-transition:enter-end": "opacity-100 scale-100",
                  "x-transition:leave": "transition ease-in duration-100",
                  "x-transition:leave-start": "opacity-100 scale-100",
                  "x-transition:leave-end": "opacity-0 scale-90"
                }, [
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                        class: "flex items-center px-4 py-2 font-medium tracking-wide text-black w-full capitalize justify-center transition-colors duration-300 transform rounded-lg focus:outline-none focus:ring bg-purple-50 hover:bg-purple-100 focus:ring-opacity-80"
                      }, _hoisted_22))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ])
        ], 2)
      ])
    ])
  ], 8, _hoisted_1))
}